module.exports = __webpack_public_path__ + "ea7c5211839438b27604858f100c4e24.MP3";